import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';

import menuIcon from '../Icons/menu-icon.svg';
import AppBreadcrumbs from './AppBreadcrumbs';
import LoadingSpinner from './LoadingSpinner';
import SideMenu from './SideMenu';

const MenuIcon = styled('img', {
  shouldForwardProp: (prop) => prop !== 'show',
})<{ show: boolean }>(({ show }) => ({
  width: '20px',
  verticalAlign: 'middle',
  transform: show ? 'rotate(0deg)' : 'rotate(180deg)',
}));

const SideMenuContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'show',
})<{ show: boolean }>(({ show }) => ({
  boxSizing: 'border-box',
  width: show ? '300px' : '0',
  paddingLeft: show ? '20px' : '0',
  flexShrink: 0,
  overflow: 'hidden',
  transition: 'width 200ms linear, padding-left 200ms linear',
}));

// Layout component with navigation
const Layout: React.FC = () => {
  const [show, setShow] = useState(true);

  return (
    <Box sx={{ padding: 2, boxSizing: 'border-box' }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <AppBreadcrumbs />
        <Stack data-testid="control-menu-icon" onClick={() => setShow(!show)} direction="row" style={{ cursor: 'pointer' }}>
          <MenuIcon src={menuIcon} alt="menu-icon" show={show} /> <Typography ml={1}>Menu</Typography>
        </Stack>
      </Stack>
      <Stack direction="row"  >
        <Box style={{
          flexGrow: 1,
          maxWidth: show ? 'calc(100vw - 333px)' : '100vw',
          transition: 'max-width 200ms linear'
        }}>
          <Suspense fallback={<LoadingSpinner />}>
            <Outlet />
          </Suspense>
        </Box>
        <SideMenuContainer show={show}>
          <SideMenu />
        </SideMenuContainer>
      </Stack>
    </Box>
  );
};
export default Layout;
